import { Injectable } from '@angular/core';

@Injectable()
export class ClasseModel {

  constructor() { }
  public id_cycleClasse:string;
  public id_niveau:string;
  public lib_classe:string;
}